var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentComponent)?_c('div',{staticClass:"factory-list"},[_c('el-card',[_c(_vm.currentComponent,{ref:"factoryListComponent",tag:"component",attrs:{"filters":_vm.filters}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }